import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { User } from '../models/auth.models';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
  urlApi = environment.urlAPI;
  user: User;
  identity;

  constructor(private http: HttpClient, private router: Router) {
  }

  /**
   * Returns the current user
   */
  public currentUser(): User {
    return getFirebaseBackend().getAuthenticatedUser();
  }

  login(user: string, password: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      usr_id: user,
      usr_clave: password,
      usr_identificador: user
    };
    return this.http.post(this.urlApi + 'AccesoUsuario/login', body, { headers, observe: 'response' });
  }

  register(params): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.urlApi + 'AccesoUsuario/Register', params, { headers, observe: 'response' });
  }

  validateCode(params): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.urlApi + 'AccesoUsuario/ValidateCode', params, { headers, observe: 'response' });
  }

  resendCode(params): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.urlApi + 'AccesoUsuario/ResendCode', params, { headers, observe: 'response' });
  }

  getHeaders() {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem('token')
    });
    return { headers };
  }

  getIdentityObs(): Observable<any> {
    const identity = JSON.parse(localStorage.getItem('permissions'));
    if (identity !== 'undefined') {
      this.identity = identity;
    }
    return of(this.identity);
  }

  getCurrentUser() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user;
  }
}

